<template>
	<div>
		<modalconfirm ref="modalconfirmProductSupplier" @action="proccessProductSupplier"/>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Produk Supplier</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<router-link class="text-deco" :to="{ name: 'add-product-supplier'}" v-if="hasAccess('add-supplier-product')">
						<v-btn light depressed class="primary">
							<v-icon>mdi-plus-circle</v-icon>
							<div class="pl-2 text-capitalize">Tambah Produk Supplier</div>
						</v-btn>
					</router-link>
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn text depressed class="primary" @click="filter()">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table loading disable-pagination :headers="headers" :items="productSupplierAll" :search="search" hide-default-footer :options.sync="option" :server-items-length="productSupplierAllPagination.total_data">
				<template v-slot:item.supplier_product_price="{ item }">
					<div class="pb-2">{{ item.supplier_product_price | toNumber }}</div>
				</template>
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="deleteProduct(item)" class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-delete</v-icon>
							</v-btn>
						</template>
						<span>Hapus</span>
					</v-tooltip>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!productSupplierAllPagination">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5">
			<v-row v-if="productSupplierAllPagination">
				<v-col cols="12" md="11" class="py-0 d-flex justify-end">
					<v-pagination @input="changePage" v-model="page" :length="productSupplierAllPagination.total_page" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete @input="changeLimit" :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import { mapActions,  mapState, mapMutations } from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			sortBy: 'product_name',
			sortDir: 'ASC',
			page: 1,
			limit: 10,
			listLimit: [ 5, 10, 20, 50, 100 ],
			paramProp: '',
			paramidProd: '',
			paramidSup: '',
			paramAction: '',
			actionProduct: '',
			val: {},
			edit: 'edit',
			dialog: false,
			dialogConfirm: false,
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Nama Produk', value: 'product_name'},
			{ text: 'Kode Produk', value: 'product_code'},
			{ text: 'Supplier', value: 'supplier_name'},
			{ text: 'Nama Produk Supplier', value: 'supplier_product_name'},
			{ text: 'Harga Beli (Rp)', value: 'supplier_product_price', align: 'end', width: "15%"},
			{ text: 'Aksi', value: 'action', sortable: false, align: 'end'},
			],
			filterData: [{
				type: 'text',
				label: 'Kode Produk',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'product_code'
				}
			}, {
				type: 'text',
				label: 'Nama Produk',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'product_name'
				}
			}, {
				type: 'text',
				label: 'Nama Produk Supplier',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'supplier_product_name'
				}
			}, {
				type: 'selection',
				label: 'Supplier',
				item: [],
				itemValue: 'supplier_id',
				itemText: 'supplier_name',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'supplier_id'
				}
			},
			],
			kode: {
				value: '',
				comparison: 'like',
				type: 'string',
				field: 'product_code'
			},
			name: {
				value: '',
				comparison: 'like',
				type: 'string',
				field: 'product_name'
			},
			supplier_product: {
				value: '',
				comparison: 'like',
				type: 'string',
				field: 'supplier_product_name'
			},
			supplier_id: {
				value: '',
				comparison: '=',
				type: 'string',
				field: 'supplier_id'
			},
			params: [],
		}
	},
	computed: {
		...mapState('productSupplier', ['productSupplierAll', 'productSupplierAllPagination']),
		...mapState('supplierList', ['supplier'])
	},
	methods: {
		...mapActions('productSupplier', ['getProductSupplierAll', 'asyncProduct', 'exportProductSupplier']),
		...mapActions('supplierList', ['getSupplierOption']),
		...mapMutations('productSupplier', ['clearDataProductSupplier']),
		...mapMutations(['setOverlay', 'setFilter']),

		getData() {
			this.getProductSupplierAll(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		exportData() {
			this.exportProductSupplier(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		filter() {
			this.dropfilter = !this.dropfilter
		},
		editStatus(stat) {
			this.paramStatus.id = stat.supplier_id
			if(stat.supplier_is_active == false) {
				this.paramStatus.status = 'inactive'
			} else{
				this.paramStatus.status = 'active'
			}
			this.statusSupplier(this.paramStatus).then(() => {
				this.getSupplier({limit:this.limit, page: this.page, params:this.params})
				this.paramStatus.id = ''
				this.paramStatus.status = ''
			})
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		onResetFilter() {
			this.params = []
			this.getData()
		},
		deleteProduct(item) {
			this.paramAction = {
				product_id: item.product_id,
				supplier_id: item.supplier_id,
				supplier_product_id: item.supplier_product_id,
			}
			this.actionProduct = 'delete'
			let msg = "Yakin akan menghapus produk supplier ini?"
			this.$refs.modalconfirmProductSupplier.showConfirm()
			this.$refs.modalconfirmProductSupplier.setMessage(msg)
		},
		async proccessProductSupplier() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmProductSupplier.hideConfirm()
			if (this.actionProduct == 'delete') {
				await this.asyncProduct(this.paramAction).then( () => {
					this.getData()
				})
			}
			await this.setOverlay(false)
		},
		changePage() {
			this.getData()
		},
		changeLimit() {
			this.page = 1
			this.getData()
		},
	},
	async created() {
		let indexSupplier = await this.filterData.findIndex(el => el.label == 'Supplier')
		this.filterData[indexSupplier].item = await this.getSupplierOption()
		await this.setFilter(this.filterData)

		this.$store.dispatch('setPageTitle', `Produk Supplier`);
		this.getData()
	},
	beforeDestroy() {
		this.clearDataProductSupplier()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'DESC' : 'ASC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
}
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>